export default "/_next/static/555aa196c7eca43b650ac709d617370a.svg";